
import { createAction, props } from "@ngrx/store";
import { VesselRotationState } from "../vessel-rotation-filter.model";

export const setVesselRotations = createAction('[VesselRotation] Set Vessel Rotations', props<{ rotations: VesselRotationState[] }>());
